/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

if (document.getElementById('FAQContent')) {
    $tabContents = $('#FAQ__tab-content');
    $navContent = $('#FAQ__nav-tabs');
    $tabContents.find('.faq-section').hide();

    $html_titles = '';
    $tabContents.find('.faq-section').each(function(i) {
      let id = $(this).attr('id');
      let title = $(this).find('.FAQ__section').data('title');
      if(title) $html_titles += '<li><a class="FAQ__nav-trigger" href="#" data-toggle="#'+id+'">'+title+'</a></li>'
    });
    $navContent.html($html_titles);

    $navContent.on('click', '.FAQ__nav-trigger', function(e) {
      e.preventDefault();
      let id = $(this).data('toggle');
      
      $tabContents.find('.faq-section').hide();
      $(id).show();
      
      $navContent.find('li').removeClass('active');
      $(this).parent().addClass('active');

      $('.FAQ__answer').hide();
      $('.FAQ__default-msg').show();
    });

    $navContent.find('li:first-child .FAQ__nav-trigger').click();
    
    $('.FAQ__question').on('click', function(e) {
      e.preventDefault();
      let answer = $(this).attr('aria-controls');
      $('.FAQ__answer').hide();
      $('#'+answer).slideDown();
      $('.FAQ__question').removeClass('active');
      $(this).addClass('active');
    })
}


(function () {

  function createStoreButtons() {
    document.querySelectorAll('.get-direction-btn').forEach(oldBtn => {

      // Stop if already processed
      if (oldBtn.dataset.processed) return;
      oldBtn.dataset.processed = 'true';

      // Hide existing button
      oldBtn.style.display = 'none';

      // Get directions URL
      const directionsUrl = oldBtn.href;

      // Try to get website URL from store title link
     const websiteAnchor = oldBtn
        .closest('.bss-info-wrapper')
        ?.querySelector('a.text-single-line[href]');

      const websiteUrl = websiteAnchor ? websiteAnchor.href : null;

      // Create wrapper
      const wrapper = document.createElement('div');
      wrapper.className = 'custom-store-buttons';

      // Create Get Directions button
      const dirBtn = document.createElement('a');
      dirBtn.className = 'custom-direction-btn';
      // dirBtn.href = directionsUrl;
      // dirBtn.target = '_blank';
      dirBtn.rel = 'noopener noreferrer nofollow';
      dirBtn.innerHTML = 'Details';

      dirBtn.style.backgroundColor = '#b08d57';
      dirBtn.style.setProperty('color', '#ffffff', 'important'); 
      dirBtn.style.border = '1px solid #b08d57';
      dirBtn.style.padding = '10px 22px';
      dirBtn.style.textDecoration = 'none';
      dirBtn.style.display = 'inline-flex';
      dirBtn.style.alignItems = 'center';
      dirBtn.style.cursor = 'pointer';

      wrapper.appendChild(dirBtn);

      // Create Visit Website button (only if exists)
      if (websiteUrl) {
        const visitBtn = document.createElement('a');
        visitBtn.className = 'custom-visit-btn';
        visitBtn.href = websiteUrl;
        visitBtn.target = '_blank';
        visitBtn.rel = 'noopener noreferrer nofollow';
        visitBtn.innerHTML = 'Visit Website';

        visitBtn.style.setProperty('color', '#1E2236', 'important'); 
        visitBtn.style.border = '1px solid ##000000';
        visitBtn.style.padding = '10px 22px';
        visitBtn.style.textDecoration = 'none';
        visitBtn.style.display = 'inline-flex';
        visitBtn.style.alignItems = 'center';

        wrapper.appendChild(visitBtn);
      }

      // Insert new wrapper after old button
      oldBtn.parentElement.appendChild(wrapper);
    });
  }

  // Initial run
  createStoreButtons();

  // Watch for dynamic app rendering
  const observer = new MutationObserver(createStoreButtons);
  observer.observe(document.body, { childList: true, subtree: true });

})();

(function () {
  function tagStoreInfoRows() {
    document.querySelectorAll('.bss-info-wrapper .store-field-info').forEach(row => {
      const label = row.querySelector('strong')?.innerText?.trim().toLowerCase();

      if (!label) return;

      if (label.includes('address')) row.classList.add('info-address');
      if (label.includes('phone')) row.classList.add('info-phone');
      if (label.includes('email')) row.classList.add('info-email');
      if (label.includes('website')) row.classList.add('info-website');
    });
  }

  tagStoreInfoRows();
  new MutationObserver(tagStoreInfoRows)
    .observe(document.body, { childList: true, subtree: true });
})();

(function () {

  function removeAddressColon() {
    document.querySelectorAll('.store-field-info.info-address').forEach(row => {
      const strong = row.querySelector('strong');
      if (!strong) return;

      // Find the text node right after <strong>
      let node = strong.nextSibling;

      if (node && node.nodeType === Node.TEXT_NODE) {
        node.textContent = node.textContent.replace(':', '');
      }
    });
    document.querySelectorAll('.store-field-info').forEach(row => {
      const strong = row.querySelector('strong');
      if (!strong) return;

      // Find the text node right after <strong>
      let node = strong.nextSibling;

      if (node && node.nodeType === Node.TEXT_NODE) {
        node.textContent = node.textContent.replace(':', '');
      }
    });
  }

  // Run once
  removeAddressColon();

  // Run again if app re-renders
  new MutationObserver(removeAddressColon)
    .observe(document.body, { childList: true, subtree: true });

})();

(function () {

  function applyButtonHoverFix() {
    document.querySelectorAll('.bss-store-result').forEach(card => {
      const btn = card.querySelector('.custom-direction-btn');
      if (!btn) return;

      // Store original styles once
      if (!btn.dataset.originalBg) {
        btn.dataset.originalBg = btn.style.backgroundColor;
        btn.dataset.originalColor = btn.style.color;
        btn.dataset.originalBorder = btn.style.border;
      }

      card.addEventListener('mouseenter', () => {
        btn.style.setProperty('background-color', '#ffffff', 'important');
        btn.style.setProperty('color', '#000000', 'important');
        btn.style.setProperty('border-color', '#ffffff', 'important');
      });

      card.addEventListener('mouseleave', () => {
        btn.style.setProperty('background-color', btn.dataset.originalBg, 'important');
        btn.style.setProperty('color', btn.dataset.originalColor, 'important');
        btn.style.setProperty('border', btn.dataset.originalBorder, 'important');
      });
    });
  }

  applyButtonHoverFix();
  new MutationObserver(applyButtonHoverFix).observe(document.body, {
    childList: true,
    subtree: true
  });

})();

(function () {

  function applyGetDirectionColor() {
    document.querySelectorAll('.ggm-iw__content--list').forEach(parent => {
      parent.querySelectorAll('.get-direction-btn span').forEach(btn => {
        btn.style.setProperty('color', '#99804C', 'important');

        // Optional: icon color
        btn.querySelectorAll('svg path').forEach(path => {
          path.style.setProperty('fill', '#000000', 'important');
          path.style.setProperty('stroke', '#000000', 'important');
        });
      });
    });
  }

  // Run once
  applyGetDirectionColor();

  // Observe dynamic rendering
  new MutationObserver(applyGetDirectionColor).observe(document.body, {
    childList: true,
    subtree: true
  });

})();

(function () {

  function applyInfoWindowRadius() {
    document
      .querySelectorAll('.gm-style-iw.gm-style-iw-c')
      .forEach(iw => {
        iw.style.setProperty('border-radius', '16px', 'important');
        iw.style.setProperty('overflow', 'hidden', 'important');
      });
  }

  // Run once
  applyInfoWindowRadius();

  // Watch for Google Maps re-render
  new MutationObserver(applyInfoWindowRadius).observe(document.body, {
    childList: true,
    subtree: true
  });

})();


document.addEventListener("click", function (e) {
    const detailsBtn = e.target.closest(".custom-direction-btn");
    if (!detailsBtn) return;

    // Get the store box that contains this Details button
    const storeBox = detailsBtn.closest(".bss-store-result");
    if (!storeBox) return;

    // Get the website button inside same store box
    const websiteBtn = storeBox.querySelector(".custom-visit-btn");
    const websiteUrl = websiteBtn ? websiteBtn.href.trim() : null;

    // Wait for popup to load
    setTimeout(() => {
        const popup = document.querySelector(".ggm-iw__content--list");
        if (!popup) return;

        // Find the Contact button inside popup
        const contactBtn = popup.querySelector(".get-direction-btn");

        if (!contactBtn) return;

        if (websiteUrl) {
            // If website exists → update link + show button
            contactBtn.href = websiteUrl;
            contactBtn.style.display = "inline-flex";
        } else {
            // If no website exists → hide the button
            contactBtn.style.setProperty("display", "none", "important");
        }
    }, 350);
});










